<template>
  <div class="flights-wrapper">
      <div v-if="currentPOI">
        <SinglePOI :currentPOI="currentPOI" :setCurrentPOI="setCurrentPOI"></SinglePOI>
      </div>
      <table v-if="!currentPOI">
        <thead>
          <tr>
            <td><WFTranslate k="time">Time</WFTranslate></td>
            <td><WFTranslate k="destination">Destination</WFTranslate></td>
            <td><WFTranslate k="flight">Flight</WFTranslate></td>
            <td></td>
            <td v-if="flightDirection == 'departures'"><WFTranslate k="gate">Gate</WFTranslate></td>
            <td><WFTranslate k="status">Status</WFTranslate></td>
            <td v-if="flightDirection == 'departures'" style="width: 25px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="flight in getFlights()" v-bind:key="flight.Flightnumber" @click="openFlightGate(flight)">
            <td v-html="getFlightTimeHtml(flight)"></td>
            <td v-html="getFlightDestinationHtml(flight)"></td>
            <td v-html="getFlightNumberHtml(flight)"></td>
            <td v-html="getFlightLogoHtml(flight)"></td>
            <td v-if="flightDirection == 'departures'">{{flight.Boardinggate}}</td>
            <td style="text-align: right;" v-html="getFlightStatusHtml(flight)"></td>
            <td v-if="flightDirection == 'departures'">
              <div v-if="getFlightGate(flight)" style="text-align: right;">
                <svg style="float: right;" width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9.63379 9.88281C10.1221 9.39453 10.1221 8.60156 9.63379 8.11328L2.13379 0.613282C1.64551 0.125001 0.852538 0.125001 0.364256 0.613282C-0.124025 1.10156 -0.124025 1.89453 0.364256 2.38281L6.98144 9L0.368164 15.6172C-0.120117 16.1055 -0.120117 16.8984 0.368164 17.3867C0.856445 17.875 1.64941 17.875 2.13769 17.3867L9.63769 9.88672L9.63379 9.88281Z" fill="#0F417C"/>
                </svg>

              </div>
            </td>
          </tr>
        </tbody>
      </table>
  </div>
</template>


<script>

import {mapState} from "vuex";
import { format } from 'date-fns';
import SinglePOI from "@/components/SinglePOI";

export default {
  components: {
    SinglePOI,
  },
  props: ['accessibleLayout'],
  data() {
    return {
      currentPOI: null,
    }
  },
  computed: {
    ...mapState('wf', ['language', 'poiGroups']),
    flightDirection() {
      return this.$store.state.flightDirection;
    },
    flights() {
      return this.$store.state.flights;
    }
  },
  methods: {
    setCurrentPOI(poi) {
      this.$store.dispatch('setPOI', poi);
      this.currentPOI = poi;
      this.$wayfinder.statistics.onClick(poi.id, "menu");
    },
    getFlightGate(flight) {
      for (const { pois } of this.poiGroups) {
        for (const poi of pois) {
          const poiName = poi.getName(this.language);
          const formattedName = poiName.split(' ').slice(-1);
          if (flight.Boardinggate == formattedName) {
            return poi;
          }
        }
      }
      return null;
    },
    openFlightGate(flight) {
      this.setCurrentPOI(this.getFlightGate(flight));
    },
    getFlightTimeHtml(flight) {
      if (flight.ARR_DEP == 'Departure') {
        if (flight.Departuretime === flight.Estimatedtime) {
          return `<div class="actual-time">${format(flight.Estimatedtime, 'HH:mm')}</div>`;
        }
        return `
            <div class="old-time">${format(flight.Departuretime, 'HH:mm')}</div>
            <div class="estimated-time">${format(flight.Estimatedtime, 'HH:mm')}</div>
        `;
      }

      if (!flight.Estimatedtime && !flight.Actualdate) {
        return '';
      }

      if (flight.Actualdate === flight.Estimatedtime) {
        return `<div class="actual-time">${format(flight.Estimatedtime, 'HH:mm')}</div>`;
      }
      if (!flight.Estimatedtime) {
        return `<div class="actual-time">${format(flight.Actualdate, 'HH:mm')}</div>`;
      }
      if (!flight.Actualdate) {
        return `<div class="actual-time">${format(flight.Estimatedtime, 'HH:mm')}</div>`;
      }
      return `
          <div class="old-time">${format(flight.Estimatedtime, 'HH:mm')}</div>
          <div class="actual-time">${format(flight.Actualdate, 'HH:mm')}</div>
      `;
    },
    getFlightStatusHtml(flight) {
      if (flight.Departed) {
        return `<div class="flight-status departed">${this.$wayfinder.translator.get('departed')}</div>`;
      }
      if (flight.ARR_DEP == 'Arrival' && flight.Landedtime) {
        return `<div class="flight-status landed">${this.$wayfinder.translator.get('landed')}</div>`;
      }
      let statuses = ['flight-status'];

      if (flight["Flightstatus " + this.language.toUpperCase()] == 'New gate') {
        statuses.push('new-gate');
      }

      var text = flight["Flightstatus " + this.language.toUpperCase()];

      const time = text.slice(-5);
      const isTime = /^(?:[01][0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$/.test(time);
      if (isTime) {
        const statusText = text.slice(0, -5);
        return `<div class="${statuses.join(' ')}"><div class="status-small">${statusText}</div>${time}</div>`;
      }

      return `<div class="${statuses.join(' ')}">${text}</div>`;
    },
    getFlightNumberHtml(flight) {
      return flight.Flightnumber;
    },
    getFlightLogoHtml(flight) {
      const logoSrc = this.getLogoSrcByAirline(flight.Airline);
      if (!logoSrc) {
        return '';
      }
      return `<span class="airline-logo-wrapper"><img src="assets/${logoSrc}" /></span>`;
    },
    getFlightDestinationHtml(flight) {
      if (flight.ARR_DEP == 'Departure') {
        return flight["Destination " + this.language.toUpperCase()];
      }
      return flight["Origin " + this.language.toUpperCase()];
    },
    getFlights() {
      return this.flightDirection == 'departures' ? this.flights?.departures ?? [] : this.flights?.arrivals ?? [];
    },
    getLogoSrcByAirline(airline) {
      switch (airline) {
        case 'airBaltic':
          return '/airlines/airbaltic.png';
        case 'Wizz Air':
          return '/airlines/Wizzair.png';
        case 'Brussels Airlines':
          return '/airlines/Brussels-Airlines.png';
        case 'SkyUp MT Limited':
          return '/airlines/SkyUp_Airlines.png';
        case 'Ryanair':
          return '/airlines/Ryanair.png';
        case 'Ryanair UK Limited':
          return '/airlines/Ryanair.png';
        case 'Norwegian Air Sweden AOC':
          return '/airlines/Norwegian.png';
        case 'Norwegian Air Shuttle AOC':
          return '/airlines/Norwegian.png';
        case 'GetJet Airlines':
          return '/airlines/GetJet.png';
        case 'Klas Jet':
          return null;
        case 'Skyline Express Airline':
          return '/airlines/Skyline-express.png';
        case 'Austrian Airlines':
          return '/airlines/austrian.png';
        case 'Fly Play hf.':
          return null;
        case 'Avion Express':
          return '/airlines/avion-logo.png';
        case 'Mavi Gök Airlines (MGA)':
          return '/airlines/Mavi_Gok_Airlines.png';
        case 'Swiss International Air Lines':
          return '/airlines/swiss.png';
        case 'Lufthansa':
          return '/airlines/hhh-Luft.png';
        case 'AirHub Airlines LTD':
          return '/airlines/Airhub-Airlines.png';
        case 'Finnair':
          return '/airlines/finnair.png';
        case 'Scandinavian Airlines SAS':
          return '/airlines/SAS.png';
        case 'Turkish Airlines':
          return '/airlines/Turkish.png';
        case 'Heston Airlines':
          return '/airlines/Heston_Airlines.png';
        case 'LOT Polish Airlines':
          return '/airlines/LOT.png';
      }
      return null;
    }
  },
  watch: {
    '$store.state.flightDirection': function() {
      this.setCurrentPOI(null);
    },
    '$store.state.flights': function() {

    },
  }
}
</script>

<style lang="postcss">
  .flights-wrapper {
    table {
      width: 100%;

      tr {
        border-bottom: 1px solid #9C9EBB;
      }

      thead {
        td {
          font-size: 1.4rem;
          font-weight: 500;
          padding-bottom: 1rem;
        }
      }

      tbody {
        tr {
          td {
            font-size: 1.6rem;
            font-weight: 600;
            padding: 10px 0;
            vertical-align: middle;
          }
        }
      }


    }

  .old-time {
    text-decoration: line-through;
    font-weight: 500;
  }
  .departed, .landed {
    color: #006600;
  }
  .new-gate {
    color: #EA5429;
  }
  .status-small {
    font-size: 1.2rem;
    font-weight: 500;
  }

    .airline-logo-wrapper {
      display: inline-block;
      border-radius: 0.8rem;
      border: 1px solid #9C9EBB;
      padding: 0.5rem;
      width: 5.6rem;
      height: 4rem;
      text-align: center;

      img {
        display: inline-block;
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
</style>
